import Axios from "axios";

export const fileDownloader = {
  download: (downloadUrl, fileName) => {
    Axios({
      url: downloadUrl,
      method: "GET",
      responseType: "blob"
    }).then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName || "download.jpg");
      document.body.appendChild(link);
      link.click();
    });
  }
};
